// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'browser-site';

export const Component = () => (
  <g fill='none' stroke='currentColor'>
    <g strokeLinecap='round' strokeLinejoin='round'>
      <path d='M14.667 6.439H3.333v6.02h11.334zM3.333 14.761H7.23m-3.897 2.208H7.23m2.478 0V14.76h4.959v2.208' />
      <path d='M1.031 16.969V2.448A1.417 1.417 0 0 1 2.448 1.03h13.104a1.417 1.417 0 0 1 1.417 1.417v14.52M1.045 4.016H16.96M4.1 1.031v2.985m3.069-2.985v2.985' />
      <path d='m6.52 12.46 2.803-3.114a1.917 1.917 0 0 1 2.921.085l2.423 3.029' />
    </g>
    <path d='M5.812 9.272a.354.354 0 0 1 0-.708m.001.708a.354.354 0 0 0 0-.708' />
  </g>
);

export const viewBox = '0 0 18 18';
